import React from "react";
import PropTypes from "prop-types";
import { Divider } from "antd";
import { path, equals } from "ramda";
import { Element } from "react-scroll";
import I18n from "../../i18n";
import ROUTE from "../../constants/route";
import { Icons } from "../../theme/index";
import { ContainerLoading, PreloadDiv } from "../../components/loading/PersistGateLoading";
import Layout from "../../components/layout/Layout";
import ThemePanel from "../../components/layout/ThemePanel";
import { DateUtil, ArrayUtil, OrgUtil, isFunction, isAlive, isFillAlive, EmployeeUtil, ColorUtil } from "../../util";
import { defaultFilterToBread, defaultFilterToRequest } from "../../util/report";
import { TargetValueType } from "./CompareValuePanel";
import ResultBox, { ResultContainer } from "../../components/report/ReportGraphResultBox";
import { ThemeBubble } from "../../components/layout/SpeechBubble";
import { DataVisualizeKeys } from "../../theme/Colors";
import { Metrics } from "../../theme";
import { ReportErrorHandler } from "../../components/report/ErrorGraphBox";
import EmployeeTable from "../../components/table/EmployeeTable";

class FilteredGraphPanel extends React.Component{
	filter = [];
	results = [];
	breadPath = [];
	maxDeepLevel = 20;

	individualContextValue = {};
	state = {
		loading:undefined
	}
	breadScroll = {};
	constructor(props){
    	super(props);
		const { dateRange, onIndividualClick } = props;
		const category_title = {};
		const out_choice = {};
		OrgUtil.getAllCategoryInfo().forEach((info, index)=>{
			const { name, choice } = info;
			category_title[name] = name;
			out_choice[`choice${index+1}`] = {data:choice};
		});
		this.individualContextValue = {
			dateRange,
			category_title,
			choice:out_choice,
			onRowClick:onIndividualClick,
			columns:EmployeeUtil.buildColumnsOverviewEmployees({ category_title }),
		};
		this.setInitFilter(props);
	}
	componentWillReceiveProps(props){
		const { dateRange } = props;
		let waitUpdate = false;
		if(!equals(this.individualContextValue.dateRange == dateRange)){
			this.individualContextValue.dateRange = dateRange;
			waitUpdate = true;
		}
		if(!equals(this.props.initFilter, props.initFilter) || 
			!equals(this.props.initBreadcrumb, props.initBreadcrumb)){
			this.setInitFilter(props);
			this.requery();
		}else if(waitUpdate){
			this.forceUpdate();
		}
	}
	componentDidMount(){
		this.setInitFilter();
		this.requery(false);
	}
	setInitFilter(props){
		const { initFilter } = props || this.props;
		const { key, value } = initFilter;
		// console.log("setInitFilter.filter: ",this.filter);
		this.setFilter(key, value,0, false);
	}
	//region Util
	keyToHeaderName(key, value){
		let out = I18n.t(key);
		out = out.charAt(0).toUpperCase() + out.substring(1);
		if(value){
			return `${out}: ${value}`;		
		}
		return out;
	}
	//endregion

	//region Request
	requestByFilter(deepLevel, filter, handler = {}, loading = true){
		const doRequest = ()=>{
			const { initFilter, fetchIndividual, fetchDeep, showCompare, filterToRequest } = this.props;
			const { recordMax, onFetched, onError } = handler;
			const targets = [TargetValueType.Primary];
			if(showCompare){
				targets.push(TargetValueType.Secondary);
			}
			let combineRes = {};
			let remain = showCompare ? 2 : 1;
			const onEachFetched = ()=>{
				remain -= 1;
				if(remain===0){
					this.saveRecord({
						index: deepLevel, 
						combineRes, 
						recordMax
					});
					if(loading){
						this.setState({loading:undefined}, onFetched);
					}else if(isFunction(onFetched)){
						onFetched();
					}
				}
			};
			const errorHandler = (type, error)=>{
				// console.error(error);
				combineRes[type] = { error };
				onEachFetched();
				if(isFunction(onError)){
					onError(error);
				}
			};
			const filterArray = this.getFilterForRequest(filter);
			// console.log("filterArray: ",filterArray);
			if(this.isIndividualLevel(deepLevel)){
				targets.forEach(t=>{
					fetchIndividual(t, filterArray).then(data=>{
						combineRes[t] = data;
						onEachFetched();
					}).catch(error=>{errorHandler(t,error);});
				});
			}else{
				targets.forEach(t=>{
					fetchDeep(t, filterArray).then(data=>{
						if(initFilter && path([initFilter.key], data)){
							delete data[initFilter.key];
						}
						combineRes[t] = data;
						onEachFetched();
					}).catch(error=>{errorHandler(t,error);});
				});
			}
		};
		// console.log(`requestByFilter ${deepLevel}: `,filter);
		if(loading){
			this.setResult(undefined, undefined, deepLevel);
			this.setState({loading:filter[filter.length-1].key},doRequest);
		}else{
			doRequest();
		}
	}
	getFilterForRequest(selectFilters){
		const { filterToRequest } = this.props;
		const targets = selectFilters || this.filter;
		return targets.map(({key,value})=>filterToRequest(key,value));
	}
	onSearchEmployee = (type, options)=>{
		const { searchEmployee } = this.props;
		console.log("onIndividualSearch: ",{options});
		return searchEmployee(type, this.getFilterForRequest(), options);
	}
	requery(scroll = true){
		let count = 0;
		let currentFilters = this.filter.slice(0, 1);
		const doQuery = ()=>{
			this.requestByFilter(count, currentFilters, {
				recordMax: count === 0,
				onFetched:()=>{
					// console.log(`done requery ${count} as filters: `,currentFilters);
					count += 1;
					currentFilters = this.filter.slice(0, count);
					if(count === this.filter.length){
						if(scroll){
							this.scrollToLastBreadcrumb();
						}
						// this.forceUpdate();
					}else{
						doQuery();
					}
				},
			});
		};
		doQuery();
	}
	saveRecord = ({index, combineRes, recordMax = false})=>{
		const { calculateDeepMax } = this.props;
		const { primary, secondary } = combineRes;
		if(recordMax){
			// const oldRecordMax = this.maxDeepLevel;
			/**
			 * Assume that the drawer is support all graph that response from server.
			 * so the max deep is equals to the number of key of summary.
			 */
			this.maxDeepLevel = primary !== undefined && 
				primary.error === undefined ? 
				calculateDeepMax(primary) : this.maxDeepLevel;
			// console.log(`max deep from ${oldRecordMax} to ${this.maxDeepLevel}`);
		}
		this.setResult(primary,  secondary, index);
	}
	//endregion
	//region UI
	toResult(primary, secondary){
		const { exclude = []} = this.props;
		const sources = [primary,secondary];
		if(exclude.length > 0){
			exclude.forEach(key => {
				sources.forEach(s=>{
					if(isAlive(s)){
						delete s[key];
					}
				});
			});
		}
    	return {
			primary, 
			secondary
    	};
	}
    onBreadcrumbLevelClick = (item,stackValue)=>{
    	const { index } = item;
    	this.flushLevel(index+1);
    	this.forceUpdate(this.scrollToLastBreadcrumb);
    }
    flushLevel(level, onFlushed){
    	this.breadPath = this.breadPath.slice(0, level);
    	this.filter = this.filter.slice(0, level);
    	this.results = this.results.slice(0, level);
    }
    setBreadPath(key, keyName, value, index){
    	const out = {
    		key, 
    		index,
    		text:this.keyToHeaderName(keyName, value), 
    		onClick:this.onBreadcrumbLevelClick
    	};
    	if(index === undefined || this.breadPath.length === index){
    		this.breadPath.push(out);
    	}else{
    		this.breadPath[index] = out;
    	}
    }
    setFilter(key, value, index, flush = true){
    	const { filterToBread } = this.props;
    	const out = {key, value};
    	if(this.filter.length === index){
    		this.filter.push(out);
    	}else{
    		this.filter[index] = out;
    		if(flush){
    			this.filter = this.filter.slice(0, index+1);
    		}
    	}
    	const bread = filterToBread(key, value);
    	this.setBreadPath(key, bread.key, bread.value, index);
    }
    setResult(primaryRes, secondaryRes, index){
    	this.results = this.results.slice(0,index);
    	const out = this.toResult(primaryRes, secondaryRes);
    	if(this.results.length === index){
    		this.results.push(out);
    	}else{
    		this.results[index] = out;
    	}
    }
    onGraphValueClick = (index, pickItem)=>{
    	const { key, item } = pickItem;
    	let value = item;
    	const requestLevel = index+1;
    	this.setFilter(key, value, requestLevel);
    	this.requestByFilter(requestLevel, this.filter, {
    		onFetched:this.scrollToLastBreadcrumb
    	});
    }
    isIndividualLevel(deepLevel){
    	return deepLevel === this.maxDeepLevel;
    }
    scrollToLastBreadcrumb = ()=>{
    	const { scrollTo } = this.props;
    	const lastFilterKey = this.filter[this.filter.length-1].key;
    	scrollTo(this.getOffsetOf(lastFilterKey));
    }
    getOffsetOf = (typeKey)=>{
    	return path(["current","childBindings","domNode","offsetTop"],this.breadScroll[typeKey]) || 0;
    }
	//endregion
    render(){
    	const { showCompare, drawList, exclude } = this.props;
    	const DrawList = drawList;
    	const filterKeys = this.filter.length > 0 ? this.filter.map(f=>f.key) : [];
    	const { loading } = this.state;
    	// console.log(`filters (${this.filter.length}) of max ${this.maxDeepLevel}: `,this.filter);
    	return <div>
    			{ArrayUtil.isAliveArray(this.results) ? 
    			this.results.map((r,index)=>{
    				const { primary, secondary } = r;
    				const isIndividual = this.isIndividualLevel(index);
    				{/* console.log(`(${index}) isIndividual ${isIndividual}: `,r); */}
    				const cutTail = index+1;
    				const pick = index === this.results.length-1 ? undefined : path(["key"], this.filter[cutTail]);
    				const comExclude = pick === undefined ? filterKeys.slice(0, cutTail) : undefined;
    				const bread = this.breadPath.slice(0, cutTail);
    				const elementID = this.filter[index].key;
    				if(this.breadScroll[elementID]===undefined){
    					this.breadScroll[elementID] = React.createRef();
    				}
    				return <div key={index}>
    					<ResultContainer path={bread}>
    					<Element ref = {this.breadScroll[elementID]} key={index} name={elementID} />
    					<ContainerLoading 
    						style={{margin:`${Metrics.button.spaceMargin}px 0px`}} 
    						isLoading={loading === this.filter[index].key} 
    						loadingChildren={<PreloadDiv />}>
    						{isIndividual ? 
    							<IndividualContext.Provider value={this.individualContextValue}> 
    								<CompareIndividual 
    									id={bread[index].key}
    									path={bread}
    									primary={primary} 
    									secondary={secondary} 
    									showCompare={showCompare}
    										searchEmployee={this.onSearchEmployee}
    								/>
    							</IndividualContext.Provider> :
    							<ResultBox
    								key={index}
    								isVertical={showCompare}
    								pick={pick}
    								colorType={TargetValueType.Primary}
    								summary={primary} 
    								previousSummary={secondary}
    								drawList={drawList}
    								exclude={comExclude}
    								onGraphValueClick={(item)=>{this.onGraphValueClick(index,item);}}
    							/>}
    					</ContainerLoading>
    				</ResultContainer>
    				</div>;
    			}) : <React.Fragment>{I18n.t("nothing_here")}</React.Fragment>}
    	</div>;
    }
}

const IndividualContext = React.createContext();

const CompareIndividual = ({id, path, primary, secondary, showCompare, searchEmployee})=>(
	<React.Fragment>
		<ReportErrorHandler value={primary}>
			<IndividualTable 
				employee={primary} 
				hilight={showCompare} 
				colorType={TargetValueType.Primary} 
				searchEmployee={searchEmployee}
			/>
		</ReportErrorHandler>
		{showCompare ? 
			<ReportErrorHandler value={secondary}>
				<IndividualTable 
					employee={secondary} 
					hilight={showCompare} 
					colorType={TargetValueType.Secondary} 
					searchEmployee={searchEmployee}
				/> 
			</ReportErrorHandler>
			: undefined}
	</React.Fragment>
);
const IndividualTable = ({employee, searchEmployee, hilight, colorType, date})=>(
	<IndividualContext.Consumer>
		{(context)=>{
			const { dateRange } = context;
			const dateText = DateUtil.toRangeString(
				dateRange[colorType][0],
				dateRange[colorType][1]
			);
			const { data, meta } = employee || {};
			return <ThemePanel 
				header={
					<Icons.CalendarIcon style={{
						display:"flex",
						lineHeight:1.5
					}}>
						<p style={{marginLeft:Metrics.button.spaceMargin}}>{dateText}</p>
					</Icons.CalendarIcon>
				} 
				headerStyle={{fontSize:Metrics.fontSize.content}}
				style={{marginBottom:Metrics.button.bigSpaceMargin}}
				colorType={hilight ? colorType : undefined}>
				<EmployeeTable 
					autoQuery={false}
					showCategory={false}
					employee={data || []} 
					employeeMeta = {meta}
					searchEmployee={(options)=>searchEmployee(colorType, options)}
					// search={false}
					{...context}
				/>
			</ThemePanel>;
		}}
	</IndividualContext.Consumer>
);

FilteredGraphPanel.defaultProps = {
	exclude:undefined,
	showCompare: false,
	initFilter:undefined,
	calculateDeepMax:(res)=>Object.keys(res).length,
	filterToRequest:defaultFilterToRequest,
	filterToBread:defaultFilterToBread,
};
FilteredGraphPanel.propTypes = {
	drawList: PropTypes.func,
	exclude: PropTypes.array,
	fetchIndividual: PropTypes.func.isRequired,
	fetchDeep: PropTypes.func.isRequired,
	searchEmployee: PropTypes.func.isRequired,
	calculateDeepMax: PropTypes.func,
	filterToBread:PropTypes.func,
};

export default FilteredGraphPanel;


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/FilteredGraphPanel.js